export const language: any = {
  add_by_image: "Ajouter en tant que photo",
  add_image_by_camera: "Prendre une photo avec l'appareil photo",
  add_image_by_gallery: "Sélectionner une photo",
  loading: "Nous préparons une délicieuse recette.\nVeuillez patienter un instant.",
  retry: "Réessayer",
  cancel: "Annuler",
  yes: "Oui",
  no: "Non",
  goToIngredient: "Analyse des ingrédients",
  goToRecipe: "Analyse du plat",
  recipe: {
    title: "Recette IA",
    analysis_results: "Résultats de l'analyse",
    ingredients: {
      title: "Ingrédients (1 portion)",
      view_more: "Voir plus d'ingrédients",
      view_less: "Réduire",
    },
    how_to_cook: "Méthode de cuisson",
    go_to_detail: "Voir la recette IA",
    description: "Présentation de la recette",
    calories: "Calories",
    time: "Temps de cuisson",
    ingredient: "Ingrédients principaux",
    spice: "Assaisonnement",
    tip: "ASTUCE",
  },
  ingredient: {
    title: "Analyse photo",
    analysis_results: "L'analyse de la photo a identifié les ingrédients suivants.",
    add_to_cart: "Ajouter au panier",
    add_to_my_ingredients: "Ajouter aux ingrédients",
  },
  msg: {
    not_ingredients: `C'est une belle photo,\nmais ici, tout tourne autour des ingrédients !\nLa prochaine fois, capturez de délicieux ingrédients –\nles secrets de la cuisine vous attendent !\nVoulez-vous aller voir le chef IA ?`,
    not_recipes: `Eh bien, ce n'est pas un plat !\nNous pouvons uniquement analyser les photos de plats préparés.\nVeuillez télécharger une photo du plat terminé.\nVoulez-vous analyser les ingrédients à la place ?`,
    not_found: "Non trouvé",
    unknow: `Je ne pense pas qu'il s'agisse d'une photo d'un plat ou d'ingrédients.\nVeuillez télécharger une photo de votre plat\nou de vos ingrédients pour l'analyse.\nNous pourrons mieux vous aider !`,
    upload_fail: `Le téléchargement a échoué en raison d'une erreur temporaire.\nVeuillez réessayer dans un instant.`,
    error: `Oh ! L'analyse de la photo n'a pas été concluante.\nSélectionnez une autre image ou\nessayons une image plus claire.`,
    bothType: `La photo contient à la fois des ingrédients et un plat !\nVeuillez sélectionner ce que vous souhaitez analyser.`,
  },
}
